module.exports = __webpack_public_path__ + "img/4.7092a5c2.jpg";